/*
 * @Author: shannyHuang
 * @Date: 2022-03-23 17:24:05
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-29 14:20:54
 * @FilePath: /wemeet-web-activity/src/components/HomeHeader/QRcodeShare.tsx
 */
import React, { useCallback, useMemo } from 'react';
// import type { FC } from 'react';
import { message } from '@tencent/tea-component';
// import QRCode from 'qrcode.react';

import copyToClipboard from 'copy-to-clipboard';
import { getBetweenDate } from '@utils/parse-date';
import { formatMeetingCode } from '@utils/format-meeting-code';
import ShareActiveModal from '@tencent/tpm-meeting-active/lib/ShareActiveModal';
import '@tencent/tpm-meeting-active/lib/ShareActiveModal/style';
import logo from '@assets/imgs/color-logo-bg.png';
import { useHostRegistrationUrl } from '@hooks/useRainbowConfig';

interface Props {
  show: boolean;
  setShow: Function;
  userName: string;
  url?: string;
  type?: 0 | 1;
  data?: any;
}

const QRCodeShare = (props: Props) => {
  const { show, setShow, userName, data, url = '', type = 0 } = props;
  const registrationUrl = useHostRegistrationUrl(data?.host_id);
  const shareUrl = useMemo(() => {
    if (data?.event_type === 0 && !data?.short_link)
      return registrationUrl.replace('[eventId]', data?.event_id);
    return data?.short_link;
  }, [data?.event_type, data?.short_link, data?.event_id, registrationUrl]);

  const copyContent = useMemo(
    () =>
      type
        ? `邀请您参加 ${userName}主办的活动，请点击下方链接查看详情。
      活动主题：${data?.meeting_title || data?.title || ''}
      活动时间：${getBetweenDate(data?.start_time, data?.end_time)}

      点击链接查看详情：
      ${shareUrl}
      ${
        data?.meeting_code
          ? `
      会议 ID：${formatMeetingCode(data?.meeting_code || '')}`
          : ''
      }`.replace(/ {2}/g, '')
        : `邀请您关注 ${userName}，及时获取主办方最新动态。
      ${url}`.replace(/ {2}/g, ''),
    [type, userName, data, url],
  );

  const copy = useCallback(() => {
    copyToClipboard(copyContent);
    message.success({ content: '复制成功' });
  }, [copyContent]);

  if (type) {
    return (
      <ShareActiveModal
        size={710}
        caption="分享活动"
        visible={show}
        activeName={data?.meeting_title || data?.title}
        activeDate={getBetweenDate(data?.start_time, data?.end_time)}
        activeUrl={shareUrl}
        activeCode={{
          link: shareUrl,
          imageSettings: {
            src: logo,
            width: 32,
            height: 32,
            excavate: false,
          },
        }}
        onClose={() => setShow(false)}
        onCopyClick={copy}
      />
    );
  }
  return (
    <ShareActiveModal.Home
      size={600}
      caption="分享主页"
      visible={show}
      homeCode={{
        link: url,
        size: 108,
        imageSettings: {
          src: logo,
          width: 24,
          height: 24,
          excavate: false,
        },
        desc: '分享主页海报',
      }}
      onClose={() => setShow(false)}
      onCopyClick={copy}
      homeInfos={
        <>
          <p>邀请您关注 {userName}，及时获取主办方最新动态。</p>
          <p>{url}</p>
        </>
      }
      v2
    ></ShareActiveModal.Home>
  );
};

export default QRCodeShare;
